import { render, staticRenderFns } from "./ProjectDetailEditor.vue?vue&type=template&id=55caaa08&"
import script from "./ProjectDetailEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports